<script lang="ts">
    import { onMount } from "svelte";

    export let borderWidth = "2px";
    export let borderRadius = "0px";
    export let duration: number = null;

    let transitionDuration = 500;
    let removeBorder = false;
    let removeWrapper = duration === null ? true : false;

    onMount(() => {

        /**
         * If duration is set we need to add and remove animated border from
         * the wrapped component
        */
        if(duration) {

            /**
             * Set the animation timer after time passes we need to remove
             * animated border from component
            */
            setTimeout(()=>{

                /**
                 * We firstly remove border width from the wrapper component so that CSS transition 
                 * can work it's magic and make removal smooth
                */
                removeBorder = true;

                /**
                 * Wait for the CSS transition to finish, then remove wrapper entierly and leave
                 * only the wrapped component (`<slot/>`)
                */
                setTimeout(() => {
                    removeWrapper = true;
                }, transitionDuration);

            }, duration);
        }
    })
</script>

<!-- We don't want to add wrappers unless the animation is running -->
{#if removeWrapper}
    <slot />
{:else}
    <div
        class='animated-border {$$props.class}'
        style="
            --border-width: {removeBorder ? "0px": borderWidth};
            --border-radius: {borderRadius};
            --transition-duration: {transitionDuration + "ms"}
            ">
        <div class="content">
            <slot />
        </div>
    </div>
{/if}

<style>
    .animated-border {
        position: relative;
        display: inline-block;
        border-radius: var(--border-radius);
        padding: var(--border-width); /* Padding creates space for the border */
        box-sizing: border-box; /* Ensures padding doesn't increase size */
        overflow: hidden; /* Keeps content within the rounded border */
        transition: all var(--transition-duration) ease;
        width: inherit;
    }

    .animated-border::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: var(--border-radius);
        background: linear-gradient(
            120deg,
            #ff4e50, /* vibrant red */ 
            #ff9a00,/* bright orange */ 
            #ffdd00,/* golden yellow */ 
            #a1ff0a,/* neon green */ 
            #0aff99,/* teal */ 
            #00cfff,/* electric blue */ 
            #5f76ff,/* vivid indigo */ 
            #ff33cc,/* hot pink */ 
            #ff4e50 /* looping back to red */
        );
        background-size: 300% 300%;
        animation: rainbow-animation 5s ease infinite;
        z-index: -1; /* Ensures the border stays behind the content */
    }

    .animated-border > .content {
        position: relative;
        z-index: 1;
        border-radius: var(--border-radius);
        background: white; /* Inner content background */
    }

    @keyframes rainbow-animation {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }
</style>
